import React, { useState, useEffect } from 'react'
import Image from '../image/image'

import './instagramFeed.css'

const InstagramFeed = ({ data }) => {
  const [insta, setInsta] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (insta && insta.length) return
    if (!insta && !error) {
      fetch(`/.netlify/functions/getIgPosts`)
        .then(res => {
          if (!res.ok) throw Error(res.statusText)
          return res
        })
        .then(res => res.json())
        .then(res => {
          setInsta(res)
        })
        .catch(error => {
          setError(JSON.stringify(error))
        })
    }
  }, [insta, error])

  return (
    <section className="instagramFeed">
      <div className="inner">
        {error && (
          <p className="text-red text-2xl text-center">
            Instagram rate limit busted, or other error occurred :( Error content --> {error}
          </p>
        )}
        {insta &&
          insta.map(post => (
            <a href={post.permalink} target="_blank" rel="noopener noreferrer" key={post.id}>
              <Image
                file={`/.netlify/functions/getIgImage?img=${encodeURIComponent(post.media_url)}`}
                alt={post.caption}
              ></Image>
            </a>
          ))}
      </div>
    </section>
  )
}

export default InstagramFeed
